module.exports = __webpack_public_path__ + "static/home-boy@large-57e676d515b0d0541571050a0c1ad8a2.jpg";